import { Box } from '@mui/material';
import { FC, useEffect, useMemo, useRef, useState } from 'react';

import styles from './components.module.css';
import CurrencyRubleIcon from '@mui/icons-material/CurrencyRuble';
import CustomButton from 'shared/custom-button/CustomButton';
import ModalWidget from 'widgets/modal/Modal';
import { useAppDispatch, useAppSelector } from 'shared/utils/hooks/useRedux';
import { IdCasePaymentShedule, LastFetchPaymentShedule, LoadingPaymentShedule, PaymentShedule } from 'entities/insurance-contract/payment-shedule/selector';
import { fetchPaymentSchedule, onFetchBill } from 'entities/insurance-contract/payment-shedule/actions/fetch-payment-schedule';
import { IPaymentSchedule } from 'entities/insurance-contract/payment-shedule/types/PaymentShedule-interface';
import ModalAnswer from 'widgets/modal-answer/ModalAnswer';
import { isValidIdCase } from 'shared/utils/hooks/useValidationIdCase';
import Loader from 'shared/loader/Loader';

import { isEqual } from 'lodash-es';

interface PaymentSchedule {
    idCase: string;
    setLoading: (isLoading: boolean) => void;
}

interface IBill {
    ID: string;
    Number: string;
}
export const PaymentSchedule: FC<PaymentSchedule> = ({ idCase, setLoading }) => {

    const dispatch = useAppDispatch();
    const PaymentSheduleData = useAppSelector(PaymentShedule);
    const lastFetch = useAppSelector(LastFetchPaymentShedule);

    const isLoading = useAppSelector(LoadingPaymentShedule);

    const [open, setOpen] = useState(false);
    const [numberBill, setNumberBill] = useState('');
    const [idBill, setIdBill] = useState('');
    const handleClose = () => {
        setOpen(false);
    };

    const [isValid, setIsValid] = useState(true);
    const stableIdContract = useMemo(() => idCase || "", [idCase]);
    const currentContract = stableIdContract;

    const isFetching = useRef(false);

    const fetchContractID = useAppSelector(IdCasePaymentShedule, isEqual);
    const oneDay = 24 * 60 * 60 * 1000;
    const shouldFetch = () => {
        const isSameParams = isEqual(currentContract, fetchContractID);
        const isDataStale = !lastFetch || (Date.now() - lastFetch > oneDay);
        return !isSameParams || isDataStale;
    };

    const fetchCaseWithValidation = () => {
        if (isValidIdCase(idCase)) {
            dispatch(fetchPaymentSchedule({ idCase }));
        } else {
            setIsValid(false)
        }
    };
    useEffect(() => {
        if (isFetching.current) return;
        if (shouldFetch()) {
            isFetching.current = true;
            fetchCaseWithValidation();
            isFetching.current = false;
        }
    }, [idCase, dispatch, lastFetch, fetchContractID]);


    const handlePayment = () => {
        setLoading(true);
        onFetchBill(idCase, setLoading, setOpen).then((e: IBill) => {
            setNumberBill(e.Number);
            setIdBill(e.ID)
        })
    }
    const handleUpdate = () => {
        fetchCaseWithValidation();
    }

    if (!isValid) {
        return (
            <p className={styles.errorText}>Некорректный ID договора</p>
        )
    } else {
        return (
            <>
                {isLoading && (
                    <Loader
                        title='Загрузка...'
                    />
                )}
                {!isLoading && (
                    <>
                        <ModalAnswer
                            open={open}
                            handleClose={handleClose}
                            numberBill={numberBill}
                            idBill={idBill}
                        />
                        <Box className={styles.shadowBox}>
                            <Box className={styles.listPaymentSchedule}>
                                <Box className={styles.headerPaymentSchedule}>
                                    <Box className={styles.headerItem}><p className={styles.border}>Дата платежа по договору</p></Box>
                                    <Box className={styles.headerItem}><p className={styles.border}>Сумма платежа</p></Box>
                                    <Box className={styles.headerItem}><p className={styles.border}>Статус оплаты</p></Box>
                                    <Box className={styles.headerItem}><p>Дата платежа</p></Box>
                                </Box>
                                {PaymentSheduleData && (
                                    <>
                                        {PaymentSheduleData.map((item: IPaymentSchedule, index: number) => (
                                            <Box key={index} className={styles.contentItemPaymentSchedule}>
                                                <Box className={styles.contentItem}><p>{item.ContractPaymentDate}</p></Box>
                                                <Box className={styles.contentItem}><p>{item.Sum} <CurrencyRubleIcon /></p></Box>
                                                <Box className={styles.contentItem}><p>{item.PaymentStatusName ? item.PaymentStatusName : '-'}</p></Box>
                                                <Box className={styles.contentItem}><p>{item.ActualPaymentDate ? item.ActualPaymentDate : '-'}</p></Box>
                                            </Box>
                                        ))
                                        }
                                    </>
                                )}
                            </Box>

                        </Box>
                        <Box className={styles.btnBoxDown}>
                            <CustomButton
                                handleClick={handlePayment}
                                title='Запросить счет'
                                textColor="white"
                                backgroundColor="#0054E6"
                                padding="5px 30px"
                                gap="10px"
                                border='none'
                                borderRadius='4px'
                            />
                            <CustomButton
                                handleClick={handleUpdate}
                                title='Обновить данные'
                                textColor="#0054E6"
                                backgroundColor="transparent"
                                padding="5px 30px"
                                gap="10px"
                                border='none'
                            />
                        </Box>
                    </>
                )}

            </>

        )
    }
}
